import { render, staticRenderFns } from "./NoItems.vue?vue&type=template&id=042d28cf&scoped=true&"
import script from "./NoItems.vue?vue&type=script&lang=js&"
export * from "./NoItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042d28cf",
  null
  
)

export default component.exports